module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-holiday-work-schedules-977be4720291dcfcef73d0037c8f372f.png";